// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"friends-family_content-wrapper__wXUrF"};